import { render, staticRenderFns } from "./PersonalizedHeader.vue?vue&type=template&id=5fda3600&scoped=true"
import script from "./PersonalizedHeader.vue?vue&type=script&lang=js"
export * from "./PersonalizedHeader.vue?vue&type=script&lang=js"
import style0 from "./PersonalizedHeader.vue?vue&type=style&index=0&id=5fda3600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda3600",
  null
  
)

export default component.exports